import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { useSelector } from 'react-redux';

export default function PatientHistoryInfo() {
  const selectedPatientData = useSelector(
    (state) => state.clinicalReducer.infertilityDetails,
  );
  const patientHistory = useSelector(
    (state) => state.clinicalReducer.patientHistory,
  );

  const examinationOfMaleData = useSelector(
    (state) => state.clinicalReducer.examinationOfMalePartner,
  );

  console.log('selectedPatientData', examinationOfMaleData);

  const historyData = {
    causeOfInfertilityPOR: selectedPatientData.causeOfInfertilityType.filter(
      (v) => v.name == 'POR',
    )
      ? [0].checked
      : false,
    causeOfInfertilityPCO: selectedPatientData.causeOfInfertilityType.filter(
      (v) => v.name == 'PCO',
    )
      ? [0].checked
      : false,
    causeOfInfertilityAGE: selectedPatientData.causeOfInfertilityType.filter(
      (v) => v.name == '>Age',
    )
      ? [0].checked
      : false,
    causeOfInfertilityAMH: selectedPatientData.causeOfInfertilityType.filter(
      (v) => v.name == '<AMH',
    )
      ? [0].checked
      : false,
    causeOfInfertilityAnovulation:
      selectedPatientData.causeOfInfertilityType.filter(
        (v) => v.name == 'Anovulation',
      )
        ? [0].checked
        : false,
    causeOfInfertilityTubalblock:
      selectedPatientData.causeOfInfertilityType.filter(
        (v) => v.name == 'Tubal block',
      )
        ? [0].checked
        : false,
    causeOfInfertilityEndometriosis:
      selectedPatientData.causeOfInfertilityType.filter(
        (v) => v.name == 'Endometriosis',
      )
        ? [0].checked
        : false,
    previousTreatment: 'None',
    semenParameters: examinationOfMaleData.tableData.map((item) => {
      return {
        volume: item.volume,
        count: item.countMml,
        aprog: item.aprog,
        sprog: item.srog,
        morphology: item.morphology,
        interpretation: item.interpretation,
      };
    }),
    backupFrozenSample: true,
  };
  console.log('examinationOfMaleData', examinationOfMaleData, historyData);
  return (
    <div className="theme-blush">
      <div className="container-fluid">
        <Card sx={{ width: '100%', padding: 2 }}>
          <CardContent>
            {/* Infertility Type */}
            <Box mb={2}>
              <Box display="flex" alignItems="center">
                <Typography variant="body1" gutterBottom>
                  <span style={{ fontWeight: 'bold' }}>
                    History Female: Type of Infertility:
                  </span>
                </Typography>
                <Checkbox
                  checked={selectedPatientData.infertilityType === 'Primary'}
                  disabled
                  sx={{ color: 'gray', '&.Mui-checked': { color: 'gray' } }}
                />
                <Typography variant="body1">Primary</Typography>
                <Checkbox
                  checked={selectedPatientData.infertilityType === 'Secondary'}
                  disabled
                  sx={{ color: 'gray', '&.Mui-checked': { color: 'gray' } }}
                />
                <Typography variant="body1">Secondary</Typography>
              </Box>
            </Box>

            {/* Cause of Infertility */}
            {/* <Typography variant="body1" gutterBottom>
              Cause of Infertility: {historyData.causeOfInfertility}
            </Typography> */}

            {/* Infertility Causes Table */}
            <Typography variant="body1" gutterBottom>
              <span style={{ fontWeight: 'bold' }}>Infertility Causes:</span>
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    {selectedPatientData.causeOfInfertilityType.map((item) => (
                      <TableCell key={item.name}>{item.label}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    {selectedPatientData.causeOfInfertilityType.map((item) => (
                      <TableCell key={item.name}>
                        {item.checked ? 'Yes' : 'No'}
                        {item.name === 'Others' && item.checked && (
                          <div>
                            {selectedPatientData.causeOfInfertilityTypeOther}
                          </div>
                        )}
                      </TableCell>
                    ))}
                    {}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            {/* Previous Treatment */}
            <Box mt={2}>
              <Typography variant="body1" gutterBottom>
                <span style={{ fontWeight: 'bold' }}>Previous Treatment:</span>
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Comments</TableCell>
                      <TableCell>No of Attempts</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.values(patientHistory.treatmentHistory).map(
                      (treatment) => (
                        <TableRow key={treatment.name}>
                          <TableCell>{treatment.name}</TableCell>
                          <TableCell>{treatment.date}</TableCell>
                          <TableCell>{treatment.comments}</TableCell>
                          <TableCell>{treatment.noOfAttempts}</TableCell>
                        </TableRow>
                      ),
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {/* Male Semen Parameters Table */}
            <Typography variant="body1" gutterBottom>
              <span style={{ fontWeight: 'bold' }}>Male Semen Parameters:</span>
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Volume</TableCell>
                    <TableCell>Count M/ml</TableCell>
                    <TableCell>A. prog</TableCell>
                    <TableCell>S. prog</TableCell>
                    <TableCell>Morphology</TableCell>
                    <TableCell>Interpretation</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {historyData.semenParameters.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {item.volume === '' ? 'N/A' : item.volume}
                      </TableCell>
                      <TableCell>
                        {item.count === '' ? 'N/A' : item.count}
                      </TableCell>
                      <TableCell>
                        {item.aprog === '' ? 'N/A' : item.aprog}
                      </TableCell>
                      <TableCell>
                        {item.sprog === '' ? 'N/A' : item.sprog}
                      </TableCell>
                      <TableCell>
                        {item.morphology === '' ? 'N/A' : item.morphology}
                      </TableCell>
                      <TableCell>
                        {item.interpretation === ''
                          ? 'N/A'
                          : item.interpretation}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Backup Frozen Sample */}
            <Box mt={2}>
              <Typography variant="body1" gutterBottom>
                <span style={{ fontWeight: 'bold' }}>
                  Back-up Frozen Sample:
                </span>
              </Typography>
              <Box display="flex" alignItems="center">
                <Checkbox
                  // checked={historyData.backupFrozenSample}
                  disabled
                  sx={{ color: 'gray', '&.Mui-checked': { color: 'gray' } }}
                />
                <Typography variant="body1" component="span" mr={2}>
                  Yes
                </Typography>
                <Checkbox
                  // checked={!historyData.backupFrozenSample}
                  disabled
                  sx={{ color: 'gray', '&.Mui-checked': { color: 'gray' } }}
                />
                <Typography variant="body1" component="span">
                  No
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
